import { render, staticRenderFns } from "./CargoCard.vue?vue&type=template&id=3291fa04&"
import script from "./CargoCard.vue?vue&type=script&lang=js&"
export * from "./CargoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports